import QualityAssuranceServiceIcon from "../icons/quality-assurance-service";
import serviceImg from "../images/software-and-apps/service-1-1536x864.png";

const QualityAssurace = () => {
  return (
    <div className="row align-items-center" id="quality-assurance-as-a-service">
      <div className="col-12 col-lg-6 text-center text-lg-start">
        <QualityAssuranceServiceIcon />
        <h2 className="fs-56 lh-64 text-danger gilroy-bold py-5">
          Quality Assurance As a Service
        </h2>
        <p className="fs-16 text-align-justify">
          Quality affirmation — the pivotal department of computer program
          improvement that screens designing forms such as include necessities,
          plan, coding, equipment setup, discharge administration, and
          persistent overhauls to guarantee client fulfillment — is being
          overturned as the world progressively gets to be more advanced. In
          spite of the fact that computer program has continuously been
          computerized, the way it’s made and guaranteed is unequivocally
          distinctive nowadays than it was fair a long time back.
        </p>
      </div>
      <div className="col-12 col-lg-6">
        <img
          src={serviceImg}
          loading="lazy"
          alt="team-img"
          className="img-fluid"
        />
      </div>
    </div>
  );
};

export default QualityAssurace;
